// Cookie consent (AEPD): the only non-essential cookies are PostHog's
// analytics, and they only load after an explicit "Aceptar". The loader
// itself lives in public/index.html (window.simaLoadAnalytics), which reads
// this same localStorage key on start-up — keep both in sync.

export const CONSENT_KEY = "cookie_consent";
export const OPEN_SETTINGS_EVENT = "sima:open-cookie-settings";

// An answer is asked again after a year, well inside the AEPD's 24 months.
const TTL_MS = 365 * 24 * 60 * 60 * 1000;

/** "accepted" | "rejected" | null (never asked, or the answer expired). */
export function readConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
    if (!c || !c.value || !(c.expires_at > Date.now())) return null;
    return c.value;
  } catch {
    return null;
  }
}

export function saveConsent(value) {
  const now = Date.now();
  try {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({ value, decided_at: new Date(now).toISOString(), expires_at: now + TTL_MS }),
    );
  } catch {
    /* private mode: the banner simply asks again next time */
  }
  if (value === "accepted") {
    window.simaLoadAnalytics?.();
    return;
  }
  // Rejected or withdrawn: stop PostHog if it was running and delete what it
  // stored, so withdrawing is as effective as never accepting.
  if (window.__simaAnalyticsLoaded && window.posthog) {
    try {
      window.posthog.opt_out_capturing();
      window.posthog.reset();
    } catch {
      /* the stub may not have finished loading */
    }
  }
  clearAnalyticsStorage();
}

/** Reopens the banner (footer "Configurar cookies"). */
export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
}

function clearAnalyticsStorage() {
  const host = window.location.hostname;
  const bare = host.replace(/^www\./, "");
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (!name.startsWith("ph_")) return;
    // PostHog may have set it on the host or on the parent domain.
    [`path=/`, `path=/; domain=${host}`, `path=/; domain=.${bare}`].forEach((scope) => {
      document.cookie = `${name}=; Max-Age=0; ${scope}`;
    });
  });
  [window.localStorage, window.sessionStorage].forEach((store) => {
    try {
      Object.keys(store)
        .filter((k) => k.startsWith("ph_") || k.startsWith("__ph"))
        .forEach((k) => store.removeItem(k));
    } catch {
      /* storage unavailable */
    }
  });
}
